import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {FormBuilder, FormControl} from '@angular/forms';
import {WeeeSystemSearch} from '../../../models/weee_system_search.interface';

@Component({
  selector: 'app-weee-system-filter',
  templateUrl: './weee-system-filter.component.html',
  styleUrls: ['./weee-system-filter.component.scss']
})
export class WeeeSystemFilterComponent implements OnInit {

  searchForm = this.formBuilder.group({
    description: [''],
    countryName: [''],
    isMember: [],
    status: [2]
  });

  get descriptionControl(): FormControl {
    return this.searchForm.get('description') as FormControl;
  }
  get countryNameControl(): FormControl {
    return this.searchForm.get('countryName') as FormControl;
  }
  get isMemberControl(): FormControl {
    return this.searchForm.get('isMember') as FormControl;
  }
  get statusControl(): FormControl {
    return this.searchForm.get('status') as FormControl;
  }

  @Output()
  search: EventEmitter<WeeeSystemSearch> = new EventEmitter<WeeeSystemSearch>();

  constructor(private formBuilder: FormBuilder) { }

  ngOnInit(): void {
  }

  handleSubmit(): void {
    const dto: WeeeSystemSearch = {
      description: this.descriptionControl.value,
      countryName: this.countryNameControl.value,
      isMember: this.isMemberControl.value,
      status: this.statusControl.value
    };
    this.search.emit(dto);
  }

  clean(): void {
    this.search.emit({});
  }

}
